query GetClosedLeadFollowupAutomation($input: FollowupLeadAutomationInput!) {
    closedLeadFollowupAutomation(input: $input) {
        newStageset {
            id
            name
        }
        assigneeOrRule {
            ... on User {
                id
                name
            }
            ... on Team {
                id
                name
            }
            ... on LeadAssigneeRule {
                assignmentRule
            }
        }
        tags {
            id
            name
        }
    }
}
